// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"add-function-list-form_wrapper__Isjbv","title":"add-function-list-form_title__1NMn-"};